import { getApiUrl } from "./api";

export class ApiStore {
	doGET() {
	}

	doPOST() {
	}

	async doFetch(method: string, path: string, opts: {jsonBody: any}) {
		const init = {
			method: method,
			mode: "cors",
			headers: {},
		} as RequestInit;
		if (opts?.jsonBody) {
			init.body = JSON.stringify(opts.jsonBody);
			(init.headers as any)["Content-Type"] = "application/json"
		}
		const resp = await fetch(getApiUrl(path), init);
		console.log(`${method} ${path}: resp: ${resp.status}/${resp.statusText}`);
		let jsn: any;
		try {
			jsn = await resp.json()
		} catch (ignore) {}
		if (200 <= resp.status && resp.status < 300) {
			return jsn;
		}
		throw new Error(`Error ${resp.status}/${resp.statusText}: ${jsn}`)
	}

	alertError(e: any) {
		alert(e?.message || "Unknown message: " + e);
	}
}

export const API_STORE = new ApiStore();